import apiService from '@/core/common/services/api.service';

export const CREATE_KUNDE_DUPLICATE_AND_ACCEPT = 'kunden.createKundeDuplicateAndAccept';

const actions = {
  [CREATE_KUNDE_DUPLICATE_AND_ACCEPT](context, { kunde1Id: kunde1Id, kunde2Id: kunde2Id }) {
    return createKundenDuplicateAndAccept(kunde1Id, kunde2Id);
  },
};

function createKundenDuplicateAndAccept(kunde1Id, kunde2Id) {
  return apiService
    .post(`Kunde/KundenDuplicates`, {
      KundeId1: kunde1Id,
      KundeId2: kunde2Id,
    })
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export default {
  actions,
};
